module.exports = __webpack_public_path__ + "img/AT0000027111929.b2a2cc13.png";